"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExpressionToReadable = void 0;
var react_1 = __importDefault(require("react"));
var lodash_1 = require("lodash");
var getImagesWithIndex = function (actualValue, matches) {
    return actualValue
        .filter(function (item) { return matches.some(function (match) { return match.input === item; }); })
        .map(function (item) { return actualValue.indexOf(item); })
        .map(function (item) { return "Image ".concat(item + 1); })
        .join(', ');
};
var getActualValue = function (blangExp) {
    var specialOperatorList = ['CONTAINS', 'NOT CONTAINS', 'NOT EQUALS', 'EQUALS', 'EXISTS', 'NOT EXISTS', 'MATCH'];
    if (specialOperatorList.indexOf(blangExp.operator) !== -1) {
        // When the operator is one of the specials, the actual value can be a long text, thus we do not show the actual value.
        return '';
    }
    if (blangExp.operator === 'SIMILAR' && blangExp.imagesGalleryOrderedPhash) {
        if ((0, lodash_1.isArray)(blangExp.actualValue)) {
            return getImagesWithIndex(blangExp.imagesGalleryOrderedPhash, blangExp.matches);
        }
        return blangExp.actualValue;
    }
    return blangExp.actualValue;
};
var getUniqueMatchedWords = function (matches) {
    var matchedWords = matches.map(function (match) { return match.word; });
    return getUniqueWords(matchedWords);
};
var getUniqueExpectedWords = function (expectedValue) {
    // expectedValue can be a string, or an array of strings
    if (Array.isArray(expectedValue)) {
        return getUniqueWords(expectedValue);
    }
    return [expectedValue];
};
var isList = function (value, expression) {
    if (Array.isArray(value)) {
        return true;
    }
    if (typeof value !== 'string') {
        return false;
    }
    if (value.charAt(0) === '@') {
        if (!expression || typeof expression !== 'string') {
            return true;
        }
        // Ugly way of making sure that when the expectedValue is thought to be list, check in the expression if
        // it's actually a list or if it's a keyword. If it's a keyword, the expression will be:
        //  $x CONTAINS "@list"
        // otherwise it will be
        //  $x CONTAINS @list
        return expression.indexOf(" \"".concat(value, "\"")) === -1;
    }
};
var getUniqueWords = function (words) {
    return words.filter(function (v, i, a) { return a.indexOf(v) === i; });
};
var operatorToText = function (operator) {
    var translate = {
        '<': 'is less than',
        '<=': 'is less than or equal to',
        '>': 'is greater than',
        '>=': 'is greater than or equal to',
        BETWEEN: 'is between',
        'NOT BETWEEN': 'is not between',
        EQUALS: 'is equal to',
        'NOT EQUALS': 'is not equal to',
        CONTAINS: 'contains keyword',
        'NOT CONTAINS': 'does not contain keyword',
        EXISTS: 'exists',
        'NOT EXISTS': 'does not exist',
        SIMILAR: 'SIMILAR',
        MATCH: 'contains confusable keyword',
    };
    return " ".concat(translate[operator], " ");
};
function UniqueMatchedWords(_a) {
    var matches = _a.matches;
    var uniqueMatchedWords = getUniqueMatchedWords(matches);
    return (react_1.default.createElement("span", null, uniqueMatchedWords.map(function (word, index) { return (react_1.default.createElement("span", { key: index },
        react_1.default.createElement("span", { className: "word-highlight" },
            String(word),
            " "))); })));
}
function ArrayExpression(_a) {
    var expression = _a.expression, angularJsDependencies = _a.angularJsDependencies, domain = _a.domain;
    var displayExpectedWordIfNotList = getUniqueExpectedWords(expression.expectedValue).map(function (word, index) {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("span", { className: "word-highlight", key: index }, word),
            "\u00A0"));
    });
    var detailsPageHref = expression.operator === 'SIMILAR'
        ? 'app.assignment.automation.phashImageListsEdit'
        : 'app.assignment.automation.dictionaryEdit';
    return (react_1.default.createElement(react_1.default.Fragment, null, Array.isArray(expression.matches) && (react_1.default.createElement(react_1.default.Fragment, null,
        isList(expression.expectedValue, expression.expression) && (react_1.default.createElement("span", null,
            expression.operator !== 'SIMILAR' && react_1.default.createElement(UniqueMatchedWords, { matches: expression.matches }),
            expression.operator !== 'SIMILAR' && react_1.default.createElement("span", null, " from list "),
            Array.isArray(expression.expectedValue) ? (react_1.default.createElement("span", null, "(".concat(expression.expectedValue.join(', '), ")"))) : (react_1.default.createElement("span", null,
                react_1.default.createElement("a", { href: angularJsDependencies.href(detailsPageHref, {
                        domain: domain,
                        name: String(expression.expectedValue).substring(1),
                    }) }, expression.expectedValue))))),
        !isList(expression.expectedValue, expression.expression) && (react_1.default.createElement(react_1.default.Fragment, null,
            (expression.operator === 'NOT CONTAINS' || expression.operator === 'NOT EQUALS') && (react_1.default.createElement(react_1.default.Fragment, null, displayExpectedWordIfNotList)),
            react_1.default.createElement(UniqueMatchedWords, { matches: expression.matches })))))));
}
function ExpressionToReadable(_a) {
    var expression = _a.expression, angularJsDependencies = _a.angularJsDependencies, domain = _a.domain;
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("span", null,
            expression.variable,
            " "),
        react_1.default.createElement("span", { className: "word-highlight" }, getActualValue(expression)),
        react_1.default.createElement("span", null, operatorToText(expression.operator)),
        react_1.default.createElement(ArrayExpression, { expression: expression, angularJsDependencies: angularJsDependencies, domain: domain }),
        !!expression.expectedRangeValue && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("span", { className: "word-highlight" }, expression.expectedValue),
            " \u00A0and",
            react_1.default.createElement("span", { className: "word-highlight" }, expression.expectedRangeValue))),
        !Array.isArray(expression.matches) && !expression.expectedRangeValue && (react_1.default.createElement("span", { className: "word-highlight" }, expression.expectedValue))));
}
exports.ExpressionToReadable = ExpressionToReadable;
